const transitionsOut = [
    //special
    {'name': 'none', 'displayName': 'None', 'professionalPremium': false, 'simplePremium': false, id: '32', inBoxAllow: true},
    { 'name': 'hinge', 'displayName': 'Hinge', 'professionalPremium': true, 'simplePremium': true, id: '23' },
    { 'name': 'rollOut', 'displayName': 'Roll Out', 'professionalPremium': false, 'simplePremium': true, id: '24' },
    { 'name': 'lightSpeedOut', 'displayName': 'Light Speed', 'professionalPremium': false, 'simplePremium': false, id: '12' },


    //bounce
    { 'name': 'bounceOut', 'displayName': 'Bounce Out', 'professionalPremium': false, 'simplePremium': false, id: '0' },
    { 'name': 'bounceOutDown', 'displayName': 'Bounce Down', 'professionalPremium': false, 'simplePremium': true, id: '1' },
    { 'name': 'bounceOutUp', 'displayName': 'Bounce Up', 'professionalPremium': false, 'simplePremium': true, id: '2' },
    { 'name': 'bounceOutRight', 'displayName': 'Bounce Right', 'professionalPremium': false, 'simplePremium': true, id: '3' },
    { 'name': 'bounceOutLeft', 'displayName': 'Bounce Left', 'professionalPremium': false, 'simplePremium': true, id: '4' },


    //fade
    { 'name': 'fadeOut', 'displayName': 'Fade Out', 'professionalPremium': true, 'simplePremium': true, id: '5' },
    { 'name': 'fadeOutDown', 'displayName': 'Fade Down', 'professionalPremium': true, 'simplePremium': true, id: '6' },
    { 'name': 'fadeOutUp', 'displayName': 'Fade Up', 'professionalPremium': true, 'simplePremium': true, id: '7' },
    { 'name': 'fadeOutLeft', 'displayName': 'Fade Left', 'professionalPremium': true, 'simplePremium': true, id: '9' },
    { 'name': 'fadeOutRight', 'displayName': 'Fade Right', 'professionalPremium': true, 'simplePremium': true, id: '8' },


    //flip
    // { 'name': 'flip', 'displayName': 'Flip', 'professionalPremium': true, id: '1' },
    { 'name': 'flipOutX', 'displayName': 'Flip X', 'professionalPremium': true, 'simplePremium': true, id: '10' },
    { 'name': 'flipOutY', 'displayName': 'Flip Y', 'professionalPremium': false, 'simplePremium': true, id: '11' },


    //rotate
    { 'name': 'rotateOut', 'displayName': 'Rotate Out', 'professionalPremium': true, 'simplePremium': true, id: '13' },
    { 'name': 'rotateOutDownLeft', 'displayName': 'Rotate Down Left', 'professionalPremium': false, 'simplePremium': true, id: '15' },
    { 'name': 'rotateOutDownRight', 'displayName': 'Rotate Down Right', 'professionalPremium': false, 'simplePremium': true, id: '14' },
    { 'name': 'rotateOutUpLeft', 'displayName': 'Rotate Up Left', 'professionalPremium': false, 'simplePremium': true, id: '17' },
    { 'name': 'rotateOutUpRight', 'displayName': 'Rotate Up Right', 'professionalPremium': false, 'simplePremium': true, id: '16' },


    //zoom
    { 'name': 'zoomOut', 'displayName': 'Zoom Out', 'professionalPremium': false, 'simplePremium': true, id: '18' },
    { 'name': 'zoomOutDown', 'displayName': 'Zoom Down', 'professionalPremium': false, 'simplePremium': true, id: '19' },
    { 'name': 'zoomOutUp', 'displayName': 'Zoom Up', 'professionalPremium': false, 'simplePremium': true, id: '20' },
    { 'name': 'zoomOutRight', 'displayName': 'Zoom Right', 'professionalPremium': true, 'simplePremium': true, id: '21' },
    { 'name': 'zoomOutLeft', 'displayName': 'Zoom Left', 'professionalPremium': true, 'simplePremium': true, id: '22' },

];

export default transitionsOut;